import "./WhatWeDo.css";
import img1 from "../assets/environmental-sustainability.jpg";
import img2 from "../assets/education&child-development.jpg";
import img3 from "../assets/skill-development-and-youth-empowerment.jpg";
import img4 from "../assets/community-development.jpg";
import { useNavigate } from "react-router-dom";


function WhatWeDo() {
  const navigate = useNavigate();
  return (
    <section className="what">
      <div className="what-container">

         <div className="what-text">
        <h2 className="what-title">What We Do</h2>
        <p className="what-subtitle">
          Four core areas drive our mission forward
        </p>
        </div>

        {/* ✅ 4 Images */}
        <div className="what-images">
          <img src={img1} alt="environmental-sustainability" />
          <img src={img2} alt="education&child-development" />
          <img src={img3} alt="skill-development-and-youth-empowerment" />
          <img src={img4} alt="community-development" />
        </div>

        {/* ✅ Button */}
        <div className="what-button">
          <button onClick={() => navigate("/our-csr")}>
            View ALl</button>
        </div>

      </div>
    </section>
  );
}

export default WhatWeDo;